import React from 'react';
import { Table, Slider, Tag, Space, Button, Tooltip } from 'antd';
import { 
  CloudOutlined, 
  CheckCircleOutlined, 
  WarningOutlined, 
  StopOutlined,
  EditOutlined,
  DeleteOutlined 
} from '@ant-design/icons';

const EndpointTable = ({ loading, endpoints, onWeightChange }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case 'healthy':
        return <CheckCircleOutlined style={{ color: '#52c41a' }} />;
      case 'warning':
        return <WarningOutlined style={{ color: '#faad14' }} />;
      case 'error':
        return <StopOutlined style={{ color: '#ff4d4f' }} />;
      default:
        return null;
    }
  };

  const getProviderIcon = (provider) => {
    const iconStyle = { fontSize: '20px' };
    switch (provider.toLowerCase()) {
      case 'aws':
        return <i className="fab fa-aws" style={iconStyle}></i>;
      case 'gcp':
        return <i className="fab fa-google" style={iconStyle}></i>;
      case 'azure':
        return <i className="fab fa-microsoft" style={iconStyle}></i>;
      default:
        return <CloudOutlined style={iconStyle} />;
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <Space>
          {getProviderIcon(record.provider)}
          <span>{text}</span>
        </Space>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: type => <Tag color="blue">{type}</Tag>,
    },
    {
      title: 'Region',
      dataIndex: 'region',
      key: 'region',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => (
        <Tag className={`status-tag ${status}`}>
          {getStatusIcon(status)} {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: 'Response Time',
      dataIndex: 'responseTime',
      key: 'responseTime',
      render: time => (
        <Tooltip title="Average response time">
          <span>{time}</span>
        </Tooltip>
      ),
    },
    {
        title: 'Traffic Weight',
        dataIndex: 'trafficWeight',
        key: 'trafficWeight',
        width: 200,
        render: (weight, record) => (
          <div style={{ padding: '8px 0', width: 100 }}>
            <div style={{ marginBottom: '4px', display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '12px' }}>Weight</span>
              <span style={{ color: 'rgba(0, 0, 0, 0.85)', fontSize: '12px' }}>{weight}%</span>
            </div>
            <Slider
              value={weight}
              onChange={(value) => onWeightChange(record.id, value)}
              tooltipVisible={false}
              style={{ margin: '4px 0' }}
            />
          </div>
        ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="small">
          <Button 
            type="text" 
            icon={<EditOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              // 編輯端點邏輯
            }}
          />
          <Button 
            type="text" 
            danger 
            icon={<DeleteOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              // 刪除端點邏輯
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <div className="endpoint-table">
      <Table 
        loading={loading}
        columns={columns} 
        dataSource={endpoints}
        rowKey="id"
        pagination={false}
      />
    </div>
  );
};

export default EndpointTable;
